module.exports = __webpack_public_path__ + "media/bootstrap-icons/eye-fill-9fcb37b7.svg";